import { IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  byoBatteryAddon,
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  ongoingBenefitPeriodKeyDetails,
} from './common/planDefaults';
import { InternetOfferPerk } from './common/internetOfferPerk';
import { createSolarInfoContent } from './common/solarInfoContent';

const PLAN_TONE = 'promoteB';

export const originSolarBoostVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Solar Boost Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing benefit period',
      },
    },
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingBenefitPeriodKeyDetails,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: [],
        dual: [...dualKeyDetailsAddons, byoBatteryAddon],
        electricity: [...electricityKeyDetailsAddons, byoBatteryAddon],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728624900/spot-illustrations/spot_Origin-Solar-Boost.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Get a boosted variable feed-in tariff',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/',
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    solarInfo: {
      defaultState: {
        defaultFuel: {
          title: 'Origin Solar Boost Variable',
          content: createSolarInfoContent(
            'Origin Solar Boost Variable (with tiered feed-in tariff)',
            true
          ),
        },
      },
    },
  },
};
